module.exports = __webpack_public_path__ + "static/device-16f9bab14462d40240db2ddb49828d6c.jpg";